<!--
 * @FileDescription: 客户优惠券
 * @Author: 陈文景
 * @Date: 2023-03-17 17:17:15
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <Web />
</template>

<script>
// Web页面已做适配移动端布局
import Web from './web/index.vue'

export default {
  components: {
    Web
  }
}
</script>
